import React from 'react';
import Button from '@material-ui/core/Button';
import './CoachPlaceholder.styl';

interface CoachPlaceholderProps {
  onClose: () => void;
  onCoachNow: () => void;
  onCreatePlan: () => void;
  callerName: string;
  isOwnCall: boolean;
}

export function CoachPlaceholder(props: CoachPlaceholderProps) {
  const {onClose, onCoachNow, onCreatePlan, callerName, isOwnCall} = props;

  if (isOwnCall) {
    return (
      <div className="add-to-plan-coach-placeholder">
        <p>You have no active plans to add this call to.</p>
        <div className={'action-bar'}>
          <Button variant="text" className="ev-button" onClick={onClose}>
            Cancel
          </Button>
        </div>
      </div>
    );
  }

  return (
    <div className={'add-to-plan-coach-placeholder'}>
      <p>{callerName} has no coaching plans. Would you like to create one?</p>

      <div className={'action-bar'}>
        <div>
          <Button variant="text" className="ev-button" onClick={onClose}>
            Cancel
          </Button>
        </div>
        <div className={'action-create'}>
          <Button variant="outlined" className="ev-button" onClick={onCoachNow}>
            Coach Now
          </Button>
          <Button variant="contained" color="primary" className="ev-button" onClick={onCreatePlan}>
            Create Coaching Plan
          </Button>
        </div>
      </div>
    </div>
  );
}
